var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgData2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 6.66666H3.33335C2.41669 6.66666 1.66669 5.91666 1.66669 5V3.33333C1.66669 2.41666 2.41669 1.66666 3.33335 1.66666H5.83335C6.75002 1.66666 7.50002 2.41666 7.50002 3.33333V5C7.50002 5.91666 6.75002 6.66666 5.83335 6.66666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 5.83333H14.3333C13.7833 5.83333 13.3333 5.38332 13.3333 4.83332V3.50001C13.3333 2.95001 13.7833 2.5 14.3333 2.5H17.3333C17.8833 2.5 18.3333 2.95001 18.3333 3.50001V4.83332C18.3333 5.38332 17.8833 5.83333 17.3333 5.83333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.0833H14.3333C13.7833 12.0833 13.3333 11.6333 13.3333 11.0833V9.75001C13.3333 9.20001 13.7833 8.75 14.3333 8.75H17.3333C17.8833 8.75 18.3333 9.20001 18.3333 9.75001V11.0833C18.3333 11.6333 17.8833 12.0833 17.3333 12.0833Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.16666H13.3333",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 4.16666V15C10.4167 15.9167 11.1667 16.6667 12.0834 16.6667H13.3334",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 4.16666V15C10.4167 15.9167 11.1667 16.6667 12.0834 16.6667H13.3334",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 10.4167H13.3334",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 18.3333H14.3333C13.7833 18.3333 13.3333 17.8833 13.3333 17.3333V16C13.3333 15.45 13.7833 15 14.3333 15H17.3333C17.8833 15 18.3333 15.45 18.3333 16V17.3333C18.3333 17.8833 17.8833 18.3333 17.3333 18.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData2);
export default __webpack_public_path__ + "static/media/data-2.71e7e2f4666f414b446502727ef6db99.svg";
export { ForwardRef as ReactComponent };